
const digest = '8e383fc0f2d1496a3ef988dd1cff065896275e3cd2c012de647c85496c8b928a';
const classes = {"wrapper":"_wrapper_qpiuq_1","header":"_header_qpiuq_7","content":"_content_qpiuq_17","item":"_item_qpiuq_23","title":"_title_qpiuq_28"};
const css = `._wrapper_qpiuq_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  border: 1px solid #ecedf3;
}
._wrapper_qpiuq_1 ._header_qpiuq_7 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #ecedf3;
  padding: 12px 24px;
  background: #fbfbfd;
}
._wrapper_qpiuq_1 ._content_qpiuq_17 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 24px;
}
._wrapper_qpiuq_1 ._content_qpiuq_17 ._item_qpiuq_23 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_qpiuq_1 ._content_qpiuq_17 ._item_qpiuq_23 ._title_qpiuq_28 {
  font-weight: 500;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  